import React, { useEffect, useRef, useState } from "react";

import { IonContent, IonModal, IonIcon, IonButton } from "@ionic/react";
import { time, call } from "ionicons/icons";

import { Spin, Timeline, Avatar, Row, Col, Empty, Divider, Typography } from "antd";
import { UserOutlined, LoadingOutlined } from "@ant-design/icons";

import moment from "moment";
import axios from "axios";
import c from "../../utils/common";

/* Global State*/ let globalState = undefined;



const { Paragraph } = Typography;

const OrderDetail = ({ order, is_loading_full_order, onGetFullDetail }) => {
  
  const [is_overdue, set_is_overdue] = useState(false);

  const scrollRef = useRef();

  const scrollToTop = async () => {
    if (scrollRef.current && scrollRef.current.scrollToTop) {
      scrollRef.current?.scrollToTop(0, 0); // Optional animation duration
    }
  };

  const getOrderTotal = () => {
    if (order == null) {
      return 0;
    }
    let total = 0;
    for (let i of order.items) {
      total += getItemTotal(i);
    }
    return total;
  };

  const getItemTotal = (item) => {
    let singleItemPrice = item.price;
    for (let e of item?.opt || []) {
      singleItemPrice += e.price;
    }
    return singleItemPrice * item.qty;
  };

  const updateIsOverdue = () => {
    if (order?.pickupTime != null) {
      console.log(moment(order.pickupTime).isBefore(moment()));
      set_is_overdue(moment(order.pickupTime).isBefore(moment()));
    }
  };

  function formatPhoneNumber(phoneNumber) {
    if (phoneNumber == null) {
      return null;
    }
    // Remove any non-numeric characters from the input phone number
    const numericOnly = phoneNumber.replace(/\D/g, "");

    // Check if the number has the correct length
    if (numericOnly.length !== 11) {
      return null;
    }

    // Extract the country code and the rest of the number
    const countryCode = numericOnly.slice(0, 3);
    const firstPart = numericOnly.slice(3, 7);
    const secondPart = numericOnly.slice(7);

    // Concatenate the formatted parts with spaces
    const formattedNumber = `${firstPart} ${secondPart}`;

    return formattedNumber;
  }

  /**
   * UI Component
   */
  const ItemList = () => {
    return (
      <Row style={{ width: "100%", backgroundColor: "#F4F4F4", borderRadius: 20, padding: 20 }}>
        <>{order?.items?.length > 0 ? order.items.map((item, i) => <Item key={i} item={item} />) : null}</>
        <Row justify="space-between" align="middle" style={{ padding: 10, width: "100%" }}>
          <Col style={{ fontSize: 26, fontWeight: "bold" }}>總結</Col>
          <Col style={{ fontSize: 32, fontWeight: "bold", paddingRight: 5 }}>${getOrderTotal()}</Col>
        </Row>
      </Row>
    );
  };

  const Item = ({ item }) => {
    return (
      <Row style={{ padding: 10, width: "100%" }}>
        {/* Main Food */}
        <Row wrap={false} align="top" gutter={10} style={{ width: "100%" }}>
          <Col flex="none" style={{ fontSize: 26, fontWeight: "bold", color: "#FFBB36" }}>
            x{item?.qty}
          </Col>
          <Col flex="auto" style={{ fontSize: 26, fontWeight: "bold" }}>
            <Row>{item?.name}</Row>
            {/* Opt */}
            {item?.opt?.length > 0 ? item?.opt.map((opt, optIndex) =>
              <Row key={optIndex} style={{ fontSize: 18 }}>{opt.name}</Row>
            ) : null}
            {/* Comment */}
            {item?.comment != null ? (
              <Row style={{ fontSize: 20 }}>
                <Paragraph style={{ color: "gray", margin: "0px" }} ellipsis={{ rows: 2, expandable: false }}>
                  {item?.comment}
                </Paragraph>
              </Row>
            ) : null}
          </Col>
          <Col flex="none" style={{ fontSize: 26, fontWeight: "bold" }}>
            {item?.price ? `$${getItemTotal(item)}` : "--"}
          </Col>
        </Row>

        <Divider style={{ margin: 0 }} />
      </Row>
    );
  };

  const ReportSection = () => {
    return (
      <Row style={{ width: "100%", marginTop: 20, marginBottom: 30 }}>
        {order?.status == "cancel_before_accept" ? <CancelBeforeAcceptReport /> : null}

        {order?.status == "accepted" ? <AcceptedReport /> : null}

        {order?.status == "rejected" ? <RejectedReport /> : null}

        {order?.status == "cancel_after_accept" ? <CancelAfterAcceptReport /> : null}

        {order?.status == "collected" ? <CollectedReport /> : null}
      </Row>
    );
  };

  const CancelBeforeAcceptReport = () => {
    return (
      <>
        <Row justify="start" style={{ width: "100%" }}>
          <Timeline mode="left" style={{ width: "100%" }}>
            <Timeline.Item label={moment(order.time.place).format("HH:mm")} style={{ fontSize: 20 }}>
              下單 <ConsumerInfo user={order?.placeBy} />
            </Timeline.Item>
            <Timeline.Item label={moment(order.time.cancel_before_accept).format("HH:mm")} style={{ fontSize: 20 }}>
              客人已取消訂單 <ConsumerInfo user={order?.cancelBeforeAcceptBy} />
            </Timeline.Item>
          </Timeline>
        </Row>
      </>
    );
  };

  const AcceptedReport = () => {
    return (
      <>
        <Row justify="start" style={{ width: "100%" }}>
          <Timeline mode="left" style={{ width: "100%" }} pending={<Row style={{ fontSize: 20 }}>尚未提取</Row>}>
            <Timeline.Item label={moment(order.time.place).format("HH:mm")} style={{ fontSize: 20 }}>
              下單 <ConsumerInfo user={order?.placeBy} />
            </Timeline.Item>
            <Timeline.Item label={moment(order.time.accept).format("HH:mm")} style={{ fontSize: 20 }}>
              <Row align="middle">
                接受訂單
                <StaffInfo user={order?.acceptBy} />
              </Row>
            </Timeline.Item>
          </Timeline>
        </Row>
      </>
    );
  };

  const RejectedReport = () => {
    return (
      <>
        <Row justify="start" style={{ width: "100%" }}>
          <Timeline mode="left" style={{ width: "100%" }}>
            <Timeline.Item label={moment(order.time.place).format("HH:mm")} style={{ fontSize: 20 }}>
              下單 <ConsumerInfo user={order?.placeBy} />
            </Timeline.Item>
            <Timeline.Item label={moment(order.time.reject).format("HH:mm")} style={{ fontSize: 20 }}>
              <Row align="middle">
                拒絕接單 <StaffInfo user={order?.rejectBy} />
              </Row>
            </Timeline.Item>
          </Timeline>
        </Row>
      </>
    );
  };

  const CancelAfterAcceptReport = () => {
    return (
      <>
        <Row justify="start" style={{ width: "100%" }}>
          <Timeline mode="left" style={{ width: "100%" }}>
            <Timeline.Item label={moment(order.time.place).format("HH:mm")} style={{ fontSize: 20 }}>
              下單 <ConsumerInfo user={order?.placeBy} />
            </Timeline.Item>
            <Timeline.Item label={moment(order.time.accept).format("HH:mm")} style={{ fontSize: 20 }}>
              <Row align="middle">
                接受訂單 <StaffInfo user={order?.acceptBy} />
              </Row>
            </Timeline.Item>

            <Timeline.Item label={moment(order.time.cancel_after_accept).format("HH:mm")} style={{ fontSize: 20 }}>
              <Row align="middle">
                商家已取消訂單 <StaffInfo user={order?.cancelAfterAcceptBy} />
              </Row>
            </Timeline.Item>
          </Timeline>
        </Row>
      </>
    );
  };

  const CollectedReport = () => {
    return (
      <>
        <Row justify="start" style={{ width: "100%" }}>
          <Timeline mode="left" style={{ width: "100%" }}>
            <Timeline.Item label={moment(order.time.place).format("HH:mm")} style={{ fontSize: 20 }}>
              下單 <ConsumerInfo user={order?.placeBy} />
            </Timeline.Item>
            <Timeline.Item label={moment(order.time.accept).format("HH:mm")} style={{ fontSize: 20 }}>
              <Row align="middle">
                接受訂單 <StaffInfo user={order?.acceptBy} />
              </Row>
            </Timeline.Item>
            <Timeline.Item label={moment(order.time.collect).format("HH:mm")} style={{ fontSize: 20 }}>
              已提取 <ConsumerInfo user={order?.collectBy?.consumer} /> <StaffInfo user={order?.collectBy?.assistant} />
            </Timeline.Item>
          </Timeline>
        </Row>
      </>
    );
  };

  const StaffInfo = ({ user }) => {
    return user?.id == null ? null : (
      <Row justify="start" align="middle" style={{ width: "100%" }}>
        <Col>
          <Avatar size={36} icon={<UserOutlined />} />
        </Col>
        <Col style={{ fontSize: 18, marginLeft: 20 }}>
          <Paragraph
            style={{
              width: "100%",
              textAlign: "start",
              margin: 0,
            }}
            ellipsis={{
              rows: 1,
            }}
          >
            員工: {user?.name}
          </Paragraph>
          {/* <Paragraph
            style={{
              width: "100%",
              textAlign: "start",
              margin: 0,
            }}
            ellipsis={{
              rows: 1,
            }}
          >
            {user?.email}
          </Paragraph> */}
        </Col>
      </Row>
    );
  };

  const ConsumerInfo = ({ user }) => {
    return user?.id == null ? null : (
      <Row justify="start" align="middle" style={{ width: "100%" }}>
        <Col>
          <Avatar size={36} icon={<UserOutlined />} />
        </Col>
        <Col style={{ fontSize: 18, marginLeft: 20 }}>
          <Paragraph
            style={{
              width: "100%",
              textAlign: "start",
              margin: 0,
            }}
            ellipsis={{
              rows: 1,
            }}
          >
            顧客: <IonIcon icon={call} />
            <strong style={{ marginLeft: 10 }}>{formatPhoneNumber(user?.tel)}</strong>
          </Paragraph>

          {/* <Paragraph
            style={{
              width: "100%",
              textAlign: "start",
              margin: 0,
            }}
            ellipsis={{
              rows: 1,
            }}
          >
            與下單人不相同
          </Paragraph> */}
        </Col>
      </Row>
    );
  };

  const PlacedSequence = () => {
    return (
      <Row align="middle" style={{ width: "100%", marginBottom: 10 }}>
        <Col span={12} style={{ fontSize: 36 }}>
          訂單#{order?.sequence}
        </Col>
        <Col span={12} style={{ textAlign: "right" }}></Col>
      </Row>
    );
  };

  const CancelBeforeAcceptSequence = () => {
    return (
      <Row align="middle" style={{ width: "100%", marginBottom: 10 }}>
        <Col style={{ fontSize: 36 }}>訂單#{order?.sequence}</Col>
        <Col
          style={{
            marginLeft: 20,
            color: "white",
            fontSize: 22,
            fontWeight: "bold",
            borderRadius: 20,
            padding: "10px 20px 10px 20px",
            backgroundColor: "#6D6D6D",
          }}
        >
          接單前取消
        </Col>
      </Row>
    );
  };

  const AcceptedSequence = () => {
    return (
      <Row align="middle" style={{ width: "100%", marginBottom: 10 }}>
        <Col style={{ fontSize: 36 }}>訂單#{order?.sequence}</Col>
        <Col
          style={{
            marginLeft: 20,
            color: "#15B565",
            fontSize: 22,
            fontWeight: "bold",
            borderRadius: 20,
            padding: "10px 20px 10px 20px",
            backgroundColor: "#DDFFD4",
          }}
        >
          已接受
        </Col>
      </Row>
    );
  };

  const RejectedSequence = () => {
    return (
      <Row align="middle" style={{ width: "100%", marginBottom: 10 }}>
        <Col style={{ fontSize: 36 }}>訂單#{order?.sequence}</Col>
        <Col
          style={{
            marginLeft: 20,
            color: "white",
            fontSize: 22,
            fontWeight: "bold",
            borderRadius: 20,
            padding: "10px 20px 10px 20px",
            backgroundColor: "#CB4900",
          }}
        >
          己拒絕接單
        </Col>
      </Row>
    );
  };

  const CancelAfterAcceptSequence = () => {
    return (
      <Row align="middle" style={{ width: "100%", marginBottom: 10 }}>
        <Col style={{ fontSize: 36 }}>訂單#{order?.sequence}</Col>
        <Col
          style={{
            marginLeft: 20,
            color: "white",
            fontSize: 22,
            fontWeight: "bold",
            borderRadius: 20,
            padding: "10px 20px 10px 20px",
            backgroundColor: "#6D6D6D",
          }}
        >
          接單後取消
        </Col>
      </Row>
    );
  };

  const CollectedSequence = () => {
    return (
      <Row align="middle" style={{ width: "100%", marginBottom: 10 }}>
        <Col style={{ fontSize: 36 }}>訂單#{order?.sequence}</Col>
        <Col
          style={{
            marginLeft: 20,
            color: "white",
            fontSize: 22,
            fontWeight: "bold",
            borderRadius: 20,
            padding: "10px 20px 10px 20px",
            backgroundColor: "#15B565",
          }}
        >
          已提取
        </Col>
      </Row>
    );
  };

  useEffect(() => {
    // console.log(order);
    scrollToTop();
  }, [order]);

  return (
    <IonContent ref={scrollRef} className="custom-scrollbar">
      {order == null ? (
        <Row justify="center" align="middle" style={{ width: "100%", height: "100%" }}>
          <Empty description="點選訂單查看詳情" style={{ fontSize: 22 }} />
        </Row>
      ) : (
        <Row style={{ fontWeight: "bold", padding: 20 }}>
          {/* Sequence */}
          {order?.status == "placed" ? <PlacedSequence /> : null}

          {order?.status == "cancel_before_accept" ? <CancelBeforeAcceptSequence /> : null}

          {order?.status == "accepted" ? <AcceptedSequence /> : null}

          {order?.status == "rejected" ? <RejectedSequence /> : null}

          {order?.status == "cancel_after_accept" ? <CancelAfterAcceptSequence /> : null}

          {order?.status == "collected" ? <CollectedSequence /> : null}

          {/* Date */}
          <Row style={{ width: "100%", marginBottom: 5 }}>
            <Col span={12} style={{ fontSize: 22 }}>
              {order?.time?.place ? moment(order.time.place).format("YYYY-MM-DD") : "--"}
            </Col>
          </Row>
          {/* Time */}
          <Row align="middle" style={{ width: "100%", marginBottom: 5 }}>
            <Col style={{ fontSize: 22 }}>
              <IonIcon icon={time} />
              {order?.pickupTime ? moment(order.pickupTime).format("HH:mm") + "提取" : "--"}
            </Col>
          </Row>
          {/* Tel */}
          {order?.placeBy?.id == null ? (
            <Row style={{ width: "100%", marginBottom: 5 }}>
              <Col span={12} style={{ fontSize: 22 }}>
                <IonButton
                  disabled={is_loading_full_order}
                  mode="ios"
                  onClick={() => {
                    onGetFullDetail(order.id);
                  }}
                  color="light"
                  style={{ "--border-radius": 0, fontSize: 22 }}
                >
                  查看詳情
                </IonButton>
              </Col>
            </Row>
          ) : null}

          <ReportSection />

          {/* Items */}
          <ItemList />

          <Row style={{ marginTop: "10vh", visibility: "hidden" }}>.</Row>
        </Row>
      )}
    </IonContent>
  );
};

export default OrderDetail;
